import {
  SubmitAppRequestMutation,
  graphqlCall,
  submitAppRequest,
} from '@akin-home/amplify';

interface SubmitAppParams {
  app_name: string;
  username: string;
}

export const submitAppRecommendation = async (params: SubmitAppParams) => {
  const results = await graphqlCall<SubmitAppRequestMutation>(
    submitAppRequest,
    params
  );

  const { data } = results;

  return data.submitAppRequest
    ? JSON.parse(data.submitAppRequest)
    : { success: false };
};
